import React from 'react';
import './About.css';

export default function AboutPage() {
  return (
    <div>
      <h1>About Page</h1>
    </div>
  );
}
